import type { HeatQualityFlag } from "src/store/api/generatedApi";

// Maps each heat-quality flag code to its translation key. This is the
// frontend half of the shared contract (the codes live in the backend
// HeatQualityFlag enum); adding a code means adding an entry here.
export const FLAG_TRANSLATION_KEY: Record<HeatQualityFlag, string> = {
  basket_count_out_of_range: "basketCountOutOfRange",
  basket_numbers_not_contiguous: "ordinalChargeNotContiguous",
  multiple_basket_numbers_per_bucket: "multipleOrdinalChargesPerBasket",
  duplicate_basket_number_across_buckets: "ordinalChargeSharedAcrossBaskets",
  multiple_loads_per_heat_bucket: "multipleLoadsPerBasket",
  bucket_loading_window_too_long: "basketLoadingWindowTooLong",
  charged_mass_deviation: "chargedMassDeviation",
  bucket_mass_out_of_range: "basketMassOutOfRange",
  loads_disagree_with_charged_buckets: "loadsDisagreeWithChargedBaskets",
  missed_consumption_drops: "missedConsumptionDrops",
  missing_charge_data: "missingChargeData",
};
